import React from "react";
import styles from "./AdvancedFertility.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { NavigationContext } from "../../../../App";
import { useContext } from "react";

const AdvancedFertility = ({ data }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

  const { setIsBackNavigation } = useContext(NavigationContext);

  return (
    <section className={styles.section}>
      {/* <img
        className={styles.pattern}
        src="https://via.placeholder.com/1200x800/000000/333333?text=Pattern"
        alt="Pattern"
      /> */}
      <img className={styles.patternTab} src="/img/patterns/advanced-tab.png" />
      <img
        src="/img/icons/AdvancedfertilityWave.svg"
        className={styles.pattern}
      />
      <div className={styles.container}>
        <div className={styles.imageWrapper}>
          <img
            className={styles.topLeft}
            src="/img/icons/top-left-corner.svg"
          ></img>
          <img
            className={styles.topRight}
            src="/img/icons/bottom-right-corner.svg"
          ></img>
          <img
            data-aos="fade-down"
            data-aos-delay="150"
            className={styles.mainImage}
            src={data?.listingItems[0]?.images[0]?.url}
            alt={data?.listingItems[0]?.images[0]?.imageTag}
          />
        </div>
        <div className={styles.content}>
          {data?.showTitle && (
            <div className={styles.titleFirst}>
              <h2
                data-aos="fade-right"
                data-aos-delay="150"
                dangerouslySetInnerHTML={{ __html: data?.title }}
              ></h2>
            </div>
          )}
          <h2
            data-aos="fade-right"
            data-aos-delay="150"
            className={styles.subtitle}
          >
            {data?.subTitle}
          </h2>
          <div className={styles.imageWrapper2}>
            <div className={styles.imageInner}>
              <img
                className={styles.mainImage2}
                src={data?.listingItems[0]?.images[0]?.url}
                alt={data?.listingItems[0]?.images[0]?.imageTag}
                data-aos="fade-down"
                data-aos-delay="150"
              />
              <img
                className={styles.topLeft}
                src="/img/icons/top-left-corner.svg"
              ></img>
              <img
                className={styles.topRight}
                src="/img/icons/bottom-right-corner.svg"
              ></img>
            </div>
          </div>
          <div
            data-aos="fade-right"
            data-aos-delay="150"
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: data?.listingItems[0]?.homeDescription,
            }}
          />
          <button
            data-aos="fade-down"
            data-aos-delay="150"
            className={`${styles.button} bg-primary-500 primary-hover2 border-primary-500`}
            onClick={() => {
              const yPos = window.scrollY;
              sessionStorage.setItem("scrollTargetY", yPos.toString());
              sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
              setIsBackNavigation(true);
              navigate(`/pages/${data?.listingItems[0]?.slug}`);
            }}
          >
            Know More
          </button>
        </div>
      </div>
    </section>
  );
};

export default AdvancedFertility;
